import React from "react";

import { DangerButton, SecondaryButton } from "~/components/common/buttons";
import { Toolbar } from "~/components/common/toolbars";
import Dialog from "~/components/generic/Dialog";

export interface DeleteSubpageDialogProps {
  isVisible: boolean;
  subpageTitle: string;
  onClose: () => void;
  onConfirmDelete: () => void;
  loading: boolean;
  error?: string;
}

export const DeleteSubpageDialog = ({
  isVisible,
  subpageTitle,
  onClose,
  onConfirmDelete,
  loading,
  error,
}: DeleteSubpageDialogProps) => {
  const cancel = () => {
    onClose();
  };

  return (
    <Dialog
      isOpen={isVisible}
      header="Delete Subpage"
      onRequestClose={cancel}
      actions={
        <Toolbar>
          <SecondaryButton onClick={cancel}>Cancel</SecondaryButton>
          <DangerButton
            disabled={loading}
            onClick={() => {
              onConfirmDelete();
            }}
          >
            Delete
          </DangerButton>
        </Toolbar>
      }
    >
      <div className="alert alert-warning">
        {`You are about to delete the subpage "${subpageTitle}". This action cannot be undone. Are you sure?`}
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
    </Dialog>
  );
};
